//  FIXME: check base-64 error
// import * as base64 from 'base-64';

// const getHostUrl = (base64EncodedUrl: string) => {
//     return base64.decode(base64EncodedUrl);
// };

// export default getHostUrl;

const getHostUrl = (base64EncodedUrl: string) => {
  return atob(base64EncodedUrl)
}

export default getHostUrl
